export const partnerProgram = Object.freeze({
  monthlyMembership: 99,
  standardMonthlyMembership: 299,
  exampleClientPrice: 299,
  commissionRate: 0.5,
  minimumClients: 5,
  enterprisePrice: 9949,
  enterpriseFindersFee: 4949,
});

export function calculatePartnerCommission(input) {
  const value = Number(input);
  const clients = Number.isFinite(value) ? Math.min(10000, Math.max(0, Math.floor(value))) : 0;
  const commission = clients * partnerProgram.exampleClientPrice * partnerProgram.commissionRate;
  const membership = clients >= partnerProgram.minimumClients ? partnerProgram.monthlyMembership : partnerProgram.standardMonthlyMembership;
  const afterMembership = commission - membership;
  return { clients, commission, membership, afterMembership, sixMonths: afterMembership * 6, meetsClientMinimum: clients >= partnerProgram.minimumClients };
}